import { render, staticRenderFns } from "./UserAgreementVivo.vue?vue&type=template&id=588cb45e&scoped=true"
import script from "./UserAgreementVivo.vue?vue&type=script&lang=js"
export * from "./UserAgreementVivo.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementVivo.vue?vue&type=style&index=0&id=588cb45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588cb45e",
  null
  
)

export default component.exports